<template>
    <v-card class="mx-3">
      <v-card-text class="d-flex justify-center">
        <img :src="foto" alt="no se encontro" class="foto">
      </v-card-text>
    </v-card>
</template>

<script>
export default {

    data () {
      return {
        foto: '',
      }
    },
    mounted () {
      this.getPathUrl()
    },
    methods: {
      //obtener parametros de url
      getPathUrl () {
        const url1 = this.getParameterByName('foto')
        const url1Replaced = url1.split('fotos')

        var url = window.location.href
        var path = url.split('/')
        var pathId = path[path.length - 1]
        const path2 = pathId.split('fotos')
        const path2Final = path2[1].replace('%3F', '?')
        const path2Final2 = path2Final.replace('%3D', '=')
        this.foto = url1Replaced[0] + 'fotos' + path2Final2
        return pathId
      },
      getParameterByName (name) {
        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        var results = regex.exec(location.search)
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
      }
    }
// https://firebasestorage.googleapis.com/v0/b/proyectouno-719dd.appspot.com/o/fotos%2FANAMARIA%20TESORO%20SILVA%20SILVAFiscalimage%204.png%3Falt%3Dmedia&token=cc42bb06-6df2-410f-93ff-5070b9ca167f 

// https://firebasestorage.googleapis.com/v0/b/proyectouno-719dd.appspot.com/o/fotos%2FANAMARIA%20TESORO%20SILVA%20SILVAFiscalimage%204.png?alt=media&token=cc42bb06-6df2-410f-93ff-5070b9ca167f
}
</script>

<style>
.foto {
  width: 100%;
  height: 100%;
}
</style>
